<template>
    <div class="pb-4">
        <div class="flex flex-wrap gap-y-2 items-center justify-between">
            <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">Communication Scenarios</h3>
                <p class="mt-1 text-sm text-gray-500">Select your default communication channels & templates for quick communication set up</p>
            </div>

            <button @click.prevent="showNewScenarioModal = true"
                    class="btn btn-primary">
                New Scenario
            </button>
        </div>

        <div v-if="!loading" class="space-y-2">
            <!--empty view-->
            <div v-if="communicationScenarios && communicationScenarios.length === 0"
                 class="text-center text-lg py-8">
                You don't have any communication scenarios yet. Try creating one.
            </div>

            <!--list of communication scenarios-->
            <div v-if="communicationScenarios && communicationScenarios.length > 0" class="pt-6">
                <div v-for="scenario in communicationScenarios">
                    <!--Communication Scenario Row-->
                    <div class="shadow-sm bg-white rounded py-3 px-4 cursor-pointer mt-4 hover:bg-indigo-50 transition duration-300"
                         @click.prevent="showEditScenarioForm(scenario.id)">
                        <div class="flex items-center justify-between">
                            <div class="flex align-items-center">
                                <h5 class="font-medium text-base">{{ scenario.name| titlecase }}</h5>
                                <div title="Default Scenario">
                                    <icon-chip v-if="scenario.is_system" class="pl-1 text-gray-300 h-2 w-2"/>
                                </div>
                            </div>

                            <span class="px-2 py-1 rounded-md font-medium" :class="getCategoryClassList(scenario.category)">
                                {{ scenario.category | titlecase }}
                            </span>
                        </div>
                    </div>
                </div>

                <simple-pagination
                    v-if="paginationData && paginationData.meta && paginationData.meta.last_page > 1"
                    :meta="paginationData.meta"
                    padding="1"
                    class="mt-4"
                    per-page="10"
                    @page-changed="fetchScenarios">
                </simple-pagination>
            </div>
        </div>

        <!--loading animation-->
        <div v-if="loading === true" class="flex justify-center py-24">
            <icon-refresh class="h-10 w-10 text-indigo-600 animate-spin"/>
        </div>

        <communication-scenario-update-create-modal
            v-if="(selectedScenarioIndex != null && selectedScenarioIndex >= 0) || showNewScenarioModal"
            :communication-scenario="selectedScenario"
            :roles="roles"
            :categories="categories"
            :scenarios="scenarioTypes"
            transition="fade" transition-mode="out-in"
            :show="(selectedScenarioIndex != null && selectedScenarioIndex >= 0) || showNewScenarioModal"
            @close="closeCreateUpdateModal()"
            @scenario-created="addScenarioToList"
            @scenario-updated="updateScenarioInList"
            @scenario-deleted="removeScenarioFromList">
        </communication-scenario-update-create-modal>
    </div>
</template>

<script>
export default {
    name: "CommunicationScenariosList",

    data () {
        return {
            showNewScenarioModal: false,
            communicationScenarios: [],
            paginationData: {},
            loading: true,
            selectedScenarioIndex: null,
            selectedScenario: null,
            categories: [],
            roles: [],
            scenarioTypes: [],
        };
    },

    mounted () {
        this.fetchSettings();
        this.fetchScenarios();
    },

    methods: {
        fetchScenarios: _.debounce(function (paginationSettings = null) {
            this.loading = true;
            axios.get("/communication-scenarios", {
                params: {
                    page: paginationSettings && paginationSettings.pageNumber ? paginationSettings.pageNumber : 1,
                    per_page: paginationSettings && paginationSettings.perPage ? paginationSettings.perPage : 10,
                }
            })
            .then((response) => {
                this.communicationScenarios = response.data.data;
                this.paginationData = response.data;
                this.loading = false;
            })
            .catch((error) => {
                this.loading = false;
                toastr.error(error.message);
            });
        }, 300),

        fetchSettings () {
            axios.get("/communication-scenarios/settings")
            .then((response) => {
                this.categories = response.data.categories;
                this.roles = response.data.roles;
                this.scenarioTypes = response.data.scenarioTypes;
            })
            .catch((error) => {
                toastr.error(error.message);
            });
        },

        showEditScenarioForm (id) {
            this.selectedScenarioIndex = this.communicationScenarios.findIndex((scenario) => scenario.id === id);
            if (this.selectedScenarioIndex !== -1) {
                this.selectedScenario = this.communicationScenarios[this.selectedScenarioIndex];
            }
        },

        addScenarioToList (newScenario) {
            this.communicationScenarios.push(newScenario);
        },

        removeScenarioFromList () {
            if (this.selectedScenarioIndex !== -1) {
                this.communicationScenarios.splice(this.selectedScenarioIndex, 1);
                if (this.communicationScenarios.length === 0) {
                    this.fetchScenarios({page: 1});
                }
            }
        },

        updateScenarioInList (updatedScenario) {
            if (this.selectedScenarioIndex !== -1) {
                this.communicationScenarios.splice(this.selectedScenarioIndex, 1, updatedScenario);
            }
        },

        closeCreateUpdateModal () {
            this.selectedScenarioIndex = null;
            this.selectedScenario = null;
            this.showNewScenarioModal = false;
        },

        getCategoryClassList (category) {
            switch (category) {
                case "maintenance": {
                    return "bg-green-100 text-green-600";
                }
                case "maintenance requests": {
                    return "bg-blue-100 text-blue-600";
                }
                case "quotes & invoices": {
                    return "bg-yellow-100 text-yellow-600";
                }
                case "inspections": {
                    return "bg-indigo-100 text-indigo-600";
                }
                default: {
                    return "bg-gray-100 text-gray-600";
                }
            }
        },
    },
};
</script>
